import { NgModule } from '@angular/core';
import { NumberValidatorDirective } from './number.validator.directive';
import { SpyDirective } from './spy.directive';

@NgModule({
  declarations: [NumberValidatorDirective, SpyDirective],
  exports: [NumberValidatorDirective, SpyDirective],
})
export class DirectivesModule {}
